import AwesomeDebouncePromise from "awesome-debounce-promise";
import * as z from "zod";

import { HonoClient } from "~/hooks/HonoContext";

export const displayName = z.string().min(3).max(32);
export const slug = z
  .string()
  .toLowerCase()
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, {
    message: "Only lowercase characters, numbers and '-' please.",
  })
  .min(3)
  .max(30);
export const password = z.string().min(8);
export const email = z.string().email();

export function createAccountSlugValidator(params: {
  apiClient: HonoClient;
  accountId?: string;
  onError?: (error: any) => void;
  onResult?: (available: boolean) => void;
}) {
  const {
    apiClient,
    accountId,
    onResult = () => undefined,
    onError = () => undefined,
  } = params;
  return AwesomeDebouncePromise(async (slug: string) => {
    if (!slug) return false;
    const res = await (accountId
      ? apiClient.accounts[":accountId"]["validate-slug"][":slug"].$get({
          param: { accountId, slug },
        })
      : apiClient.auth["validate-slug"][":slug"].$post({ param: { slug } }));
    if (res.ok) {
      const available = await res.json().then((data) => data.available);
      onResult(available);
      return available;
    }
    console.error("Failed to validate slug", res);
    onError(res);
    return false;
  }, 300);
}
